import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import React from "react";

import TaskToolTip from "./taskToolTip";
import HelperText from "../../../../../../components/feedback/helper-text/";
import { getUnitPropertie } from "../../functions";

function TaskFieldCheckbox(props) {
  const handleOnChange = (event) => {
    const { attributes, onChange } = props;
    const data = event.target.checked;
    const camundaValue = { type: "Boolean", value: data, valueInfo: {} };
    onChange && onChange(attributes.id, data, camundaValue);
  };

  const {
    showValidate,
    error,
    className,
    readOnly,
    attributes,
    value,
    style,
    size,
    fieldProperties,
  } = props;

  const isRequired = getUnitPropertie(fieldProperties, "isRequired");
  const label = getUnitPropertie(fieldProperties, "label");
  const color = getUnitPropertie(fieldProperties, "color");
  const toolTip = getUnitPropertie(fieldProperties, "toolTip");

  const switchSize = size ? "small" : "medium";

  return (
    <TaskToolTip title={toolTip}>
      <FormControl
        key={"divPadrao" + attributes.id}
        margin="normal"
        style={style}
        fullWidth
      >
        <FormControlLabel
          control={
            showValidate && error ? (
              <Switch
                error={error || ""}
                toggle="true"
                className={className}
                checked={value || false}
                onChange={!readOnly ? handleOnChange : undefined}
                size={switchSize}
                color={color}
              />
            ) : (
              <Switch
                onChange={!readOnly ? handleOnChange : undefined}
                error={undefined}
                toggle="true"
                className={className}
                checked={value || false}
                size={switchSize}
                color={color}
              />
            )
          }
          label={isRequired ? label + " *" : label}
        />
        {showValidate && error && <HelperText>{error}</HelperText>}
      </FormControl>
    </TaskToolTip>
  );
}

// const mapStateToProps = createStructuredSelector({
//   value: (state, props) => selectFilterFormValuesSelector(state, props.id),
// });
// const mapDispatchToProps = {};

export default TaskFieldCheckbox;
